import { TextInput } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

export interface FormViewProps {
  date: string;
  graduationGrade: string;
  degreeGrade?: string;
  distinctionRank: string;
  registerCode?: string;
}

const dictPrefix = 'studentsDegreeStudent';

export default function FormView(props: FormViewProps) {
  const { t } = useTranslation();

  const texts = useMemo(
    () => ({
      distinctionRankLabel: t(`${dictPrefix}.form.distinctionRank`),
      graduationGradeLabel: t(`${dictPrefix}.form.graduationGrade`),
      degreeGradeLabel: t(`${dictPrefix}.form.degreeGrade`),
      dateLabel: t(`${dictPrefix}.form.date`),
      registerCodeLabel: t(`${dictPrefix}.form.registerCode`),
    }),
    [t],
  );

  return (
    <>
      <Row>
        <Col className="pb-3" xs={12} xl={4}>
          <TextInput
            name="distinctionRank"
            label={texts.distinctionRankLabel}
            value={props.distinctionRank}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={2}>
          <TextInput
            name="date"
            label={texts.dateLabel}
            value={dayjs(props.date).format('DD/MM/YYYY')}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={2}>
          <TextInput
            name="registerCode"
            label={texts.registerCodeLabel}
            value={props.registerCode}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={2}>
          <TextInput
            name="graduationGrade"
            label={texts.graduationGradeLabel}
            value={props.graduationGrade}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={2}>
          <TextInput
            name="degreeGrade"
            label={texts.degreeGradeLabel}
            value={props.degreeGrade}
            readOnly
          />
        </Col>
      </Row>
    </>
  );
}
